import { useMemo } from "react";
import { Work } from "../../../types/work";
import {
  AncillaryConnection,
  SYSTEM_ANCILLARY_TYPE_LABELS,
} from "../../../types/ancillary";
import {
  SystemEntityCollections,
  SystemEntityProofreadingStatus,
} from "../../../shared/enums/shared-enums";
import { initMetadata } from "../../../controllers/formController";

const useAncillaryLogic = (from: Work | null, to: Work | null) => {
  const metadataFieldNames = useMemo<Array<keyof AncillaryConnection>>(
    () => ["work_ancillary_type"],
    []
  );

  const workAncillaryEnum = useMemo<string>(() => {
    return "work_ancillary";
  }, []);

  const userEnums = useMemo<string[]>(
    () => [workAncillaryEnum],
    [workAncillaryEnum]
  );

  const defaultAncillary = useMemo<AncillaryConnection>(
    () => ({
      _from: from?._id || "",
      _to: to?._id || "",
      _id: "",
      _key: "",
      _rev: "",
      work_ancillary_type: null,
      fromDoc: from
        ? { ...from, _collection: SystemEntityCollections.WORK }
        : null,
      toDoc: to ? { ...to, _collection: SystemEntityCollections.WORK } : null,
      entity_status_of_proofreading:
        SystemEntityProofreadingStatus.NOT_PROOFREAD,
      internal_notes: "",
      attributes_metadata:
        initMetadata<AncillaryConnection>(metadataFieldNames),
      notes: "",
    }),
    [from, to, metadataFieldNames]
  );

  const getDisplayName = (ancillary: AncillaryConnection) =>
    `${ancillary.work_ancillary_type ? SYSTEM_ANCILLARY_TYPE_LABELS[ancillary.work_ancillary_type] : "Unknown"} Ancillary Connection`;

  return {
    workAncillaryEnum,
    userEnums,
    defaultAncillary,
    metadataFieldNames,
    getDisplayName,
  };
};

export default useAncillaryLogic;
